import styled from 'styled-components';

//keeping styled component here as 'MyAccountIconStyled' is used in automated testing
export const MyAccountIconStyled = styled.div``;

export const CartCountWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledLogo = styled.span`
  width: 115px;
`;

export const LoginButton = styled.button`
  text-align: right;
  display: inline-block;
  vertical-align: middle;
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 11px;
  letter-spacing: 1.5px;
  padding: 0;
  text-transform: uppercase;
  font-family: 'Lato', Lato, sans-serif;
  transition: color, 0.15s, ease-in;

  &:hover {
    color: #959595;
  }

  &:after {
    content: 'Login';
  }
`;

export const LoginContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  .DesktopNav__LoginLoader {
    min-width: 2.5rem;
    margin: 0;
  }
`;
